import React from 'react'
import cx from 'classnames'
import { SearchInput as SearchingInput } from '@manychat/manyui'

const SearchInput = React.forwardRef((props, ref) => {
  const { hidden, ...rest } = props
  return (
    <div
      className={cx('p-relative p-x-xs', { 'p-y-xxs b-b': !hidden, 'o-hidden': hidden })}
      style={{ maxHeight: hidden ? 0 : 'none' }}
    >
      <SearchingInput inputRef={ref} {...rest} />
    </div>
  )
})

export default SearchInput
